export const omniChatMessages = {
  nameFeature: 'Chat KH',
  customerBeingSupported: 'KH đang hỗ trợ',
  notHaveChatSessions: 'Chưa hỗ trợ KH nào',
  descriptionReceiveCustomer: 'Nhấn nhận chat để nhận hỗ trợ cho một khách hàng đang chờ',
  receiveChat: 'Nhận chat',
  waitingCustomer: 'KH đang chờ',
  complete: 'Kết thúc',
  notHaveWaitingCustomer: '0 Khách hàng đang chờ',
  assign: 'Phân công',
  assignChat: 'Phân công chat',
  searchCustomer: 'Tên khách hàng',
  chooseCustomerAssign: 'Chọn một khách hàng đang chờ để xem nội dung tin nhắn và bắt đầu phân công',
  chooseDTV: 'Chọn điện thoại viên',
  nameDTV: 'Tên điện thoại viên',
  confirmAssign: 'Xác nhận phân công',
  notPermission: 'Bạn không có quyền chat khách hàng',
  chatSession: 'cuộc chat',
  likeComment: 'Thích bình luận',
  hideComment: 'Ẩn bình luận',
  unhideComment: 'Bỏ ẩn bình luận',
  deleteComment: 'Xóa bình luận',
  chatCustomer: 'Chat riêng với khách hàng',
  reply: 'Trả lời bình luận',
  openLinkComment: 'Mở link bình luận',
  ready: 'Sẵn sàng',
  pause: 'Tạm ngưng',
  messageDeleted: 'Tin nhắn đã xóa',
  reAssign: 'Phân công lại',
  forwardShiftLeader: 'Chuyển trưởng ca',
  confirmForwardShiftLeader: 'Bạn có chắc muốn chuyển chat này cho trưởng ca không?',
  selectCustomerPlaceholder: 'Nhập tên khách hàng cần tìm',
  selectSourcePlaceholder: 'Chọn kênh chat',
  extension: 'Extension',
  customerName: 'Tên khách hàng',
  channelChat: 'Kênh chat',
  time: 'Thời gian',
  ongoing: 'Đang diễn ra',
  historyChat: 'Lịch sử chat',
  searchFollow: 'Tìm kiếm theo',
  validateSearch: 'Vui lòng chọn tên khách hàng hoặc extension để thực hiện tra cứu',
  ongoingChat: 'Chat đang xử lý',
  chooseDTVToAssign: 'Chọn điện thoại viên phân công',
  assignDTV: 'Phân công điện thoại viên',
  supportCustomer: 'hỗ trợ khách hàng',
  chatDetails: 'Thông tin cuộc chat',
  supportingDTV: 'Điện thoại viên đang hỗ trợ',
  processingTime: 'Thời gian xử lý',
  extensionNo: 'Số Extension',
  findChatSession: 'Tìm kiếm cuộc chat',
  allChannelsChat: 'Tất cả kênh chat',
  emptyDescription: 'Vui lòng kiểm tra lại thông tin nhập vào để tìm kiếm',
  waitingCustomers: 'khách đang chờ',
  noContact: 'Không tìm thấy liên hệ',
  ticketId: 'ID phiếu',
  customerNameCompact: 'Tên KH',
};
